import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-creation-analysis-progress',
  templateUrl: './creation-analysis-progress.component.html'
})
export class CreationAnalysisProgressComponent implements OnInit, OnDestroy, OnChanges {
  // Presentational component: supports indeterminate mode (null) or determinate percent (0-100).
  // When no `progressPercent` is provided, the component will simulate a demo percentage.
  @Input() progressPercent: number | null = null;
  @Input() statusMessage: string | null = null;

  // Internal simulated percentage used when no input is provided
  simulatedPercent = 0;
  // Stagnation / retry UI
  private lastProgress: number | null = null;
  private stagnationTimer: any = null;
  showRetryUi = false;
  retryExplanation: string | null = null;
  private readonly STAGNATION_MS = 2 * 60 * 1000; // 2 minutes

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('progressPercent' in changes) {
      const cur = changes['progressPercent'].currentValue;
      this.handleProgressChange(cur);
    }

    if ('statusMessage' in changes) {
      const msg = changes['statusMessage'].currentValue as string | null;
      if (msg && msg.includes('Nettoyage : Fichiers temporaires supprimés')) {
        this.triggerRetryUi('Le serveur a signalé un nettoyage des fichiers temporaires — l\'analyse a été interrompue. Veuillez réessayer en rafraîchissant la page.');
      }
    }
  }

  ngOnDestroy(): void {
    this.clearStagnationTimer();
  }


  get determinate(): boolean {
    return (this.progressPercent != null && !isNaN(this.progressPercent as any));
  }

  get boundedPercent(): number {
    const source = (this.progressPercent != null && !isNaN(this.progressPercent as any)) ? this.progressPercent as number : this.simulatedPercent;
    const p = Math.round((source || 0));
    return Math.max(0, Math.min(100, p));
  }

  private handleProgressChange(cur: any): void {
    this.showRetryUi = false;
    const progress = (cur != null && !isNaN(cur)) ? Number(cur) : null;

    if (progress == null) {
      this.lastProgress = null;
      this.clearStagnationTimer();
      return;
    }

    if (this.lastProgress === null || progress !== this.lastProgress) {
      this.lastProgress = progress;
      this.clearStagnationTimer();
      if (progress < 100) {
        this.stagnationTimer = setTimeout(() => {
          this.triggerRetryUi('Aucune progression détectée. Veuillez rafraîchir la page et réessayer.');
        }, this.STAGNATION_MS);
      }
    }
    if (progress === 100) {
      this.clearStagnationTimer();
    }
  }

  private clearStagnationTimer(): void {
    if (this.stagnationTimer) {
      clearTimeout(this.stagnationTimer);
      this.stagnationTimer = null;
    }
  }

  private triggerRetryUi(explanation: string): void {
    this.clearStagnationTimer();
    this.retryExplanation = explanation;
    this.showRetryUi = true;
  }

  refreshPage(): void {
    try { window.location.reload(); } catch { /* noop */ }
  }
}
